import { render, staticRenderFns } from "./CombatantHealthDialog.vue?vue&type=template&id=25ae404a&"
import script from "./CombatantHealthDialog.vue?vue&type=script&lang=js&"
export * from "./CombatantHealthDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports